import {
  FETCH_PATIENTS_REQUEST,
  FETCH_PATIENTS_SUCCESS,
  FETCH_PATIENTS_FAILURE,
  FETCH_PATIENTS_COUNT_REQUEST,
  FETCH_PATIENTS_COUNT_SUCCESS,
  FETCH_PATIENTS_COUNT_FAILURE,
  SET_SELECTED_PATIENT,
  CLEAR_SELECTED_PATIENT,
  FETCH_PATIENTPRESCRLIST_REQUEST,
  FETCH_PATIENTPRESCRLIST_SUCCESS,
  FETCH_PATIENTPRESCRLIST_FAILURE,
  FETCH_PATIENTLABTESTSLIST_REQUEST,
  FETCH_PATIENTLABTESTSLIST_SUCCESS,
  FETCH_PATIENTLABTESTSLIST_FAILURE,
  SET_PATIENTREGISTRATION_PAYLOAD,
  CLEAR_PATIENTREGISTRATION_PAYLOAD,
  SET_SELECTEDEDIT_PATIENT,
  CLEAR_SELECTEDEDIT_PATIENT,
  PATIENT_FILTER_ENABLED,
  PATIENT_FILTER_CLEAR,
} from "../actions/patientActions";

const initialState = {
  patientsList: [],
  prescriptionsList: [],
  labTestsList: [],
  selectedPatient: null,
  selectedEditPatient: null,
  registrationPayload: null,
  totalCount: 0,
  isLoading: false,
  error: null,
  patientFilter: false,
};

export const patientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PATIENTS_REQUEST:
      return { ...state, isLoading: true };

    case FETCH_PATIENTS_SUCCESS:
      return { ...state, patientsList: action.payload, isLoading: false };

    case FETCH_PATIENTS_FAILURE:
      return { ...state, error: action.payload, isLoading: false };

    case FETCH_PATIENTS_COUNT_REQUEST:
      return { ...state, isLoading: true };

    case FETCH_PATIENTS_COUNT_SUCCESS:
      return { ...state, totalCount: action.payload, isLoading: false };

    case FETCH_PATIENTS_COUNT_FAILURE:
      return { ...state, error: action.payload, isLoading: false };

    case FETCH_PATIENTPRESCRLIST_REQUEST:
      return { ...state, isLoading: true };

    case FETCH_PATIENTPRESCRLIST_SUCCESS:
      return { ...state, prescriptionsList: action.payload, isLoading: false };

    case FETCH_PATIENTPRESCRLIST_FAILURE:
      return { ...state, error: action.payload, isLoading: false };

    case FETCH_PATIENTLABTESTSLIST_REQUEST:
      return { ...state, isLoading: true };

    case FETCH_PATIENTLABTESTSLIST_SUCCESS:
      return { ...state, labTestsList: action.payload, isLoading: false };

    case FETCH_PATIENTLABTESTSLIST_FAILURE:
      return { ...state, error: action.payload, isLoading: false };

    case SET_SELECTED_PATIENT:
      return { ...state, selectedPatient: action.payload };

    case CLEAR_SELECTED_PATIENT:
      return { ...state, selectedPatient: action.payload };

    case SET_PATIENTREGISTRATION_PAYLOAD:
      return { ...state, registrationPayload: action.payload };

    case CLEAR_PATIENTREGISTRATION_PAYLOAD:
      return { ...state, registrationPayload: action.payload };

    case SET_SELECTEDEDIT_PATIENT:
      return { ...state, selectedEditPatient: action.payload };

    case CLEAR_SELECTEDEDIT_PATIENT:
      return { ...state, selectedEditPatient: action.payload };

    case PATIENT_FILTER_ENABLED:
      return { ...state, patientFilter: action.payload };

    case PATIENT_FILTER_CLEAR:
      return { ...state, patientFilter: action.payload };

    default:
      return state;
  }
};
